
import incidents from './incidents.json';
import catalogTasks from './catalog_tasks.json';

export const getIncidents = () => {
  try {
    console.log("Getting incidents, type:", typeof incidents);
    // Make sure we return a proper array
    if (incidents && Array.isArray(incidents)) {
      return incidents;
    } else if (incidents && typeof incidents === 'object') {
      // If it's an object but not an array, check if it has data property
      const anyIncidents = incidents as any;
      if (Array.isArray(anyIncidents.data)) {
        return anyIncidents.data;
      }
    }
    console.warn("Incidents data is not in expected format, returning empty array");
    return [];
  } catch (error) {
    console.error('Error loading incidents:', error);
    return [];
  }
};

export const getCatalogTasks = () => {
  try {
    console.log("Getting catalog tasks, type:", typeof catalogTasks);
    // Make sure we return a proper array
    if (catalogTasks && Array.isArray(catalogTasks)) {
      return catalogTasks;
    } else if (catalogTasks && typeof catalogTasks === 'object') {
      // If it's an object but not an array, check if it has data property
      const anyCatalogTasks = catalogTasks as any;
      if (Array.isArray(anyCatalogTasks.data)) {
        return anyCatalogTasks.data;
      }
    }
    console.warn("Catalog tasks data is not in expected format, returning empty array");
    return [];
  } catch (error) {
    console.error('Error loading catalog tasks:', error);
    return [];
  }
};
